<h4 [class.small]="small">
  {{ title }}
  @if (soon) {
  <span class="label label-orange">SOON</span>
  } @if (permission) { @if ('!' + permission | permissions: gallery) {
  <app-pro-tag
    [location]="location"
    [permission]="permission"
    [tenantId]="gallery['tenant']?.['id'] || gallery['tenant']"
  ></app-pro-tag>
  } }
</h4>
<p class="standard-text" [class.small]="small">
  <ng-content></ng-content>
</p>
